var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as formActions } from 'react-redux-form';
import { Translate } from "../../I18N";

import { hideModal } from "../../Modals/actions/modalActions";
import Modal from "../../Layout/Modal";
import { Icon } from "../../UI";
import { closePanel } from "../actions/uiActions";

export class ConfirmCloseForm extends Component {
  confirm() {
    this.props.hideModal('ConfirmCloseForm');
    this.props.closePanel();
    this.props.resetForm('documentViewer.sidepanel.metadata');
  }

  render() {
    if (!this.props.doc) {
      return false;
    }

    const { doc } = this.props;

    return /*#__PURE__*/(
      _jsx(Modal, { isOpen: !!doc, type: "danger" }, void 0, /*#__PURE__*/
      _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
      _jsx("h4", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Confirm")
      ), /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "All changes will be lost, are you sure you want to proceed?")
      )
      ), /*#__PURE__*/

      _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-default cancel-button",
        onClick: () => this.props.hideModal('ConfirmCloseForm') }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "times" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Cancel")
      ), /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-danger confirm-button",
        onClick: () => this.confirm() }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "trash-alt" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Ok")
      )
      )
      ));

  }
}








const mapStateToProps = (state) => ({ doc: state.modals.get('ConfirmCloseForm') });

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closePanel, hideModal, resetForm: formActions.reset }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmCloseForm);